module.exports = __webpack_public_path__ + "static/availability_4-f64941fe3f73d13f828138df27eac446.jpg";